import { render, staticRenderFns } from "./event-asset-box.vue?vue&type=template&id=f1926fea&scoped=true"
import script from "./event-asset-box.vue?vue&type=script&lang=js"
export * from "./event-asset-box.vue?vue&type=script&lang=js"
import style0 from "./event-asset-box.vue?vue&type=style&index=0&id=f1926fea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1926fea",
  null
  
)

export default component.exports